import { useLocation } from '@reach/router'
import { CLICK_SUGGEST_TITLE_BUTTON_EVENT } from 'amplitude/events'
import useLogEventToAll from 'utils/useLogEventToAll'

const useLogSuggestTitle = ({ action }) => {
  const logEvent = useLogEventToAll()
  const { pathname } = useLocation()

  return location => {
    const source = `From path: ${pathname}`

    const params = {
      'Button Type': location ?? source,
      Path: pathname,
      Source: location ?? source,
      Action: action,
    }

    logEvent(CLICK_SUGGEST_TITLE_BUTTON_EVENT, params)
  }
}

export default useLogSuggestTitle
